export default __webpack_public_path__ + "static/pool-lounge-86ef2e71b12b1251485cb5a6ac7f5961.jpg";